export const SAVE_QUOTE_RESPONSE = "SAVE_QUOTE_RESPONSE"

export interface QuoteResponseData {   
    launchpadId: string;
    redirectUrl: string; 
    success: boolean;
    message: string;   
    carrierCode: string;
    isAuthenticated: boolean;
}

export interface SaveQuoteResponse {
    type: typeof SAVE_QUOTE_RESPONSE;
    data: QuoteResponseData
}
